import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { WidgetContextService } from 'src/app/services/widget-context.service';

@Component({
    selector: 'app-iframe-widget',
    templateUrl: './iframe-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './iframe-widget.component.scss'],
    standalone: false
})
export class IframeWidgetComponent extends BaseWidgetComponent implements OnInit, OnDestroy {
  @Input() url: string = '';
  @Input() title: string = 'Widget';

  public safeUrl: SafeResourceUrl | null = null;
  public loading = true;
  public error: string | null = null;

  constructor(private sanitizer: DomSanitizer, private _widgetContext: WidgetContextService) {
    super();
  }

  ngOnInit(): void {
    if (this.url) {
      this.loadUrl(this.url);
      this._widgetContext.updateContext({
        widgetId: this.id,
        widgetType: 'IframeApp',
        state: { title: this.title, url: this.url },
      });
    } else {
      this.error = 'No URL configured for this widget';
      this.loading = false;
    }
  }

  ngOnDestroy(): void {
    this._widgetContext.removeContext(this.id);
  }

  private loadUrl(url: string): void {
    try {
      // Sanitize the URL for iframe embedding
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.loading = false;
    } catch (e) {
      this.error = `Failed to load URL: ${e}`;
      this.loading = false;
    }
  }

  onIframeLoad(): void {
    this.loading = false;
  }

  onIframeError(): void {
    this.error = 'Failed to load content';
    this.loading = false;
  }

  refresh(): void {
    if (this.url) {
      this.loading = true;
      this.error = null;
      // Force reload by temporarily clearing and resetting the URL
      this.safeUrl = null;
      setTimeout(() => this.loadUrl(this.url), 100);
    }
  }
}
